interface IAffordability {
    rentOrMortgageMonthlyPayment: number | null;
    utilitiesMonthlyPayment: number | null;
    insuranceMonthlyPayment: number | null;
    creditCardMonthlyPayment: number | null;
    circumstancesLikelyToChange: boolean | null;
    circumstancesLikelyToChangeReason: string | null;
}

class Affordability implements IAffordability {
    rentOrMortgageMonthlyPayment: number | null;
    utilitiesMonthlyPayment: number | null;
    insuranceMonthlyPayment: number | null;
    creditCardMonthlyPayment: number | null;
    circumstancesLikelyToChange: boolean | null;
    circumstancesLikelyToChangeReason: string | null;

    constructor();
    constructor(params?: IAffordability) {
        this.rentOrMortgageMonthlyPayment = params?.rentOrMortgageMonthlyPayment || null;
        this.utilitiesMonthlyPayment = params?.utilitiesMonthlyPayment || null;
        this.insuranceMonthlyPayment = params?.insuranceMonthlyPayment || null;
        this.creditCardMonthlyPayment = params?.creditCardMonthlyPayment || null;
        this.circumstancesLikelyToChange = params?.circumstancesLikelyToChange || null;
        this.circumstancesLikelyToChangeReason = params?.circumstancesLikelyToChangeReason || null;
    }
}

export type { IAffordability };
export { Affordability };